import * as React from 'react';

import { Button, Props as ButtonProps } from '../Button';
import { classes } from '../utils';

import styles from './styles.module.css';

type PhoenixPrimaryButtonProps = {
  color?: 'neutral' | 'red' | 'blue';
  colorMode?: 'light' | 'dark';
};

export type PrimaryButtonProps = ButtonProps &
  PhoenixPrimaryButtonProps & {
    /** @deprecated use version=phoenix and color prop */
    variant?: 'default' | 'accent' | 'dark' | 'error';
    /** @deprecated all primary buttons are rounded now */
    rounded?: boolean;
    /** @deprecated with no replacement */
    bold?: boolean;
  };

export const PrimaryButton = React.forwardRef<
  HTMLButtonElement,
  PrimaryButtonProps
>(function PrimaryButtonComponent(props: PrimaryButtonProps, ref) {
  const {
    bold = true,
    variant = 'default',
    size = 'default',
    name = 'primary-button',
    rounded,
    version = undefined,
    color = 'neutral',
    colorMode = 'light',
    disabled,
    unstyled,
    className,
  } = props;

  const cx =
    version === 'phoenix'
      ? classes(
          [
            className,
            styles[`primaryButton-${version}`],
            styles[color],
            styles[colorMode],
            styles[disabled ? 'disabled' : ''],
            styles[size],
          ],
          {
            ...props,
            unstyled,
            name,
          }
        )
      : classes(
          [
            className,
            styles.primaryButton,
            styles[variant],
            styles[size],
            {
              [styles.bold]: bold,
              [styles['rounded-btn']]: rounded,
            },
          ],
          {
            ...props,
            unstyled,
            name,
          }
        );

  // Phoenix uses Icon for both left and right icons. iconPosition controls
  // if it is left or right
  const { ActionIcon: _ActionIcon, ...phoenixPassthroughProps } = props;

  const passthroughProps =
    version === 'phoenix' ? phoenixPassthroughProps : props;

  return <Button {...passthroughProps} name={name} className={cx} ref={ref} />;
});
